
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// The production HTML is prerendered (scripts/prerender.mjs), so #root already
// holds server markup: adopt it with hydrateRoot instead of throwing it away and
// re-rendering. That wholesale re-render was what let a mid-render browser
// translation pass leave duplicated / mixed-language text behind. In `vite dev`
// the root is empty, so fall back to a normal client render.
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  ReactDOM.createRoot(rootElement).render(app);
}
